/* 谷仓 数据字典 */

// 联系人客户类型
export const customerTypeEnum = [
  { value: 1, label: '个人', lang: 'enum.customerType1' },
  { value: 2, label: '企业', lang: 'enum.customerType2' }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const customerPhaseEnum = [
  { value: 2, label: '潜在客户', lang: 'enum.customerPhase2' },
  { value: 3, label: '签约客户', lang: 'enum.customerPhase3' },
  { value: 4, label: '成交客户 ', lang: 'enum.customerPhase4' }
]
// 成交客户评级
export const customerGradeEnum = [
  { value: 1, label: '⭐' },
  { value: 2, label: '⭐⭐' },
  { value: 3, label: '⭐⭐⭐' },
  { value: 4, label: '⭐⭐⭐⭐' },
  { value: 5, label: '⭐⭐⭐⭐⭐' }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const clueAndcustomerPhaseEnum = [
  { label: '线索阶段', lang: 'enum.customerPhase1', value: 1 },
  ...customerPhaseEnum
]
// 潜在客户状态
export const potentialStatusEnum = [
  {
    value: 10,
    label: '谈判',
    lang: 'enum.customerStaus10',
    descLang: 'enum.customerStausDes10',
    desc: '一切协商、交涉、商量、磋商等',
    color: '#EF8D3C'
  },
  {
    value: 12,
    label: '搁置',
    lang: 'enum.customerStaus12',
    descLang: 'enum.customerStausDes12',
    desc: '半年内无法达成合作',
    color: '#EF8D3C'
  },
  {
    value: 14,
    label: '归档',
    descLang: 'enum.customerStausDes14',
    lang: 'enum.customerStaus14',
    desc: '无合作可能',
    color: '#DF443B'
  }
]
// 签约客户状态
export const contractStatusEnum = [
  { label: '对接中', lang: 'enum.customerStaus20', value: 20, color: '#EF8D3C' },
  { label: '暂停合作', lang: 'enum.customerStaus21', value: 21, color: '#EF8D3C' },
  { label: '终止合作', lang: 'enum.customerStaus22', value: 22, color: '#DF443B' }
]
// 成交客户状态
export const clientsStatusEnum = [
  {
    label: '磨合',
    lang: 'enum.customerStaus31',
    value: 31,
    descLang: 'enum.customerStausDes31',
    desc: '首次发货到 6 个月以内的客户',
    color: '#EF8D3C'
  },
  {
    label: '上涨',
    lang: 'enum.customerStaus32',
    value: 32,
    descLang: 'enum.customerStausDes32',
    desc: '业务量上涨的客户',
    color: '#EF8D3C'
  },
  {
    label: '下降',
    lang: 'enum.customerStaus33',
    value: 33,
    descLang: 'enum.customerStausDes33',
    desc: '业务量下降的客户',
    color: '#EF8D3C'
  },
  {
    label: '保持',
    lang: 'enum.customerStaus35',
    value: 35,
    descLang: 'enum.customerStausDes35',
    desc: '业务量稳定的客户',
    color: '#EF8D3C'
  },
  {
    label: '流失',
    lang: 'enum.customerStaus36',
    value: 36,
    descLang: 'enum.customerStausDes36',
    desc: '停止合作的客户',
    color: '#DF443B'
  }
]
export const customerAllStatusEnum = [
  { label: '线索公海池', lang: 'enum.customerStaus0', value: 0 },
  { label: '待领取', lang: 'enum.customerStaus1', value: 1 },
  { label: '待跟进', lang: 'enum.customerStaus2', value: 2 },
  { label: '跟进中', lang: 'enum.customerStaus3', value: 3 },
  { label: '无效线索', lang: 'enum.customerStaus5', value: 5 },
  { label: '已转换', lang: 'enum.customerStaus8', value: 8 },
  { label: '谈判', lang: 'enum.customerStaus10', value: 10 },
  { label: '已注册', lang: 'enum.customerStaus11', value: 11 },
  { label: '搁置', lang: 'enum.customerStaus12', value: 12 },
  { label: '无合作可能', lang: 'enum.customerStaus13', value: 13 },
  { label: '归档', lang: 'enum.customerStaus14', value: 14 },
  { label: '对接中', lang: 'enum.customerStaus20', value: 20 },
  { label: '暂停合作', lang: 'enum.customerStaus21', value: 21 },
  { label: '终止合作', lang: 'enum.customerStaus22', value: 22 },
  { label: '已签约', lang: 'enum.customerStaus30', value: 30 },
  { label: '磨合', lang: 'enum.customerStaus31', value: 31 },
  { label: '上涨', lang: 'enum.customerStaus32', value: 32 },
  { label: '下降', lang: 'enum.customerStaus33', value: 33 },
  { label: '稳定', lang: 'enum.customerStaus34', value: 34 },
  { label: '保持', lang: 'enum.customerStaus35', value: 35 },
  { label: '流失', lang: 'enum.customerStaus36', value: 36 }
]
// ark账号状态
export const arkCodeStatusEnum = [
  { value: 0, label: '待审核', lang: 'arkCode.arkCode0' },
  { value: 1, label: '审核不通过', lang: 'arkCode.arkCode1' },
  { value: 2, label: '审核通过', lang: 'arkCode.arkCode2' },
  { value: 3, label: '已停用', lang: 'arkCode.arkCode3' },
  { value: 4, label: '冻结', lang: 'arkCode.arkCode4' },
  { value: 5, label: '限制', lang: 'arkCode.arkCode5' }
]
// 客户未跟进天数
export const customerUnfollowDayTypeEnum = [
  { value: 1, label: '3天以内', lang: 'enum.within3' },
  { value: 2, label: '7天以内', lang: 'enum.within7' },
  { value: 3, label: '15天以内', lang: 'enum.within15' },
  { value: 4, label: '超过15天', lang: 'enum.over15' }
]
// 剩余跟进天数类型 超时（小于0天）、3天以内（0-3天）、7天以内、15天以内、超过15天
export const remanentFollowDayTypeEnum = [
  { value: 5, label: '超时', lang: 'enum.overDue' },
  { value: 1, label: '3天以内', lang: 'enum.within3' },
  { value: 2, label: '7天以内', lang: 'enum.within7' },
  { value: 3, label: '15天以内', lang: 'enum.within15' },
  { value: 4, label: '超过15天', lang: 'enum.over15' }
]
//
export const flagEnum = [
  { value: 1, label: '是', lang: 'enum.yes' },
  { value: 0, label: '否', lang: 'enum.no' }
]
export const enterpriseScaleEnum = [
  { value: 1, label: '1~100人', lang: 'enum.' },
  { value: 2, label: '100~500人', lang: 'enum.' },
  { value: 3, label: '500~1000人', lang: 'enum.' },
  { value: 4, label: '1000人以上', lang: 'enum.' }
]
export const contactTypeEnum = [
  { value: 1, label: '法人', lang: 'enum.contactType1' },
  { value: 2, label: '收货人', lang: 'enum.contactType2' }
]
// 性别
export const genderEnum = [
  { value: 1, label: '先生', lang: 'enum.mr' },
  { value: 2, label: '女士', lang: 'enum.miss' },
  { value: 3, label: '夫人', lang: 'enum.mrs' }
]
/* 联系人角色类型 */
export const linkRoleTypeEnum = [
  { value: 1, label: '采购者', lang: 'enum.linkRoleType1' },
  { value: 2, label: '决策者', lang: 'enum.linkRoleType2' },
  { value: 3, label: '使用者', lang: 'enum.linkRoleType3' }
]
// 商机状态
export const businessStatusEnum = [
  {
    label: '新客评审通过',
    lang: 'enum.businessStatus1',
    value: 1,
    color: '#EF8D3C',
    disabled: false,
    descLang: 'enum.businessStatus1Dec',
    desc: '新客评审通过'
  },
  {
    label: '客户激活完成',
    lang: 'enum.businessStatus2',
    value: 2,
    color: '#EF8D3C',
    disabled: false,
    descLang: 'enum.businessStatus2Dec',
    desc: '客户激活完成'
  },
  // {
  //   label: '确认需求',
  //   lang: 'enum.businessStatus2',
  //   value: 2,
  //   color: '#EF8D3C',
  //   disabled: false,
  //   descLang: 'enum.businessStatus2Dec',
  //   desc: '确认客户有海外仓需求'
  // },
  // {
  //   label: '制定方案',
  //   lang: 'enum.businessStatus4',
  //   value: 3,
  //   color: '#EF8D3C',
  //   disabled: false,
  //   descLang: 'enum.businessStatus4Dec',
  //   desc: '制定合作方案，解决双方合作的疑难问题'
  // },
  {
    label: '客户成交',
    lang: 'enum.businessStatus5',
    value: 4,
    color: '#3FAC46',
    descLang: 'enum.businessStatus5Dec',
    disabled: false,
    desc: '客户成交'
  },
  {
    label: '未能合作',
    lang: 'enum.businessStatus6',
    value: 5,
    color: '#DF443B',
    disabled: false,
    descLang: 'enum.businessStatus6Dec',
    desc: '半年内不能达成合作的客户'
  }
]
// 商机订单类型枚举
export const orderTypeEnum = [
  { label: '头程', value: 1, lang: 'enum.orderType1' },
  { label: '尾程', value: 2, lang: 'enum.orderType2' }
]
// 异动类型枚举
export const alarmTypeEnum = [
  { label: '激活异动', value: 1, lang: 'enum.alarmTypeEnum1' },
  { label: '流失异动', value: 2, lang: 'enum.alarmTypeEnum2' },
  { label: '余额异动', value: 3, lang: 'enum.alarmTypeEnum3' },
  { label: '入库异动', value: 4, lang: 'enum.alarmTypeEnum4' },
  { label: '出库异动', value: 5, lang: 'enum.alarmTypeEnum5' },
  { label: '在库异动', value: 6, lang: 'enum.alarmTypeEnum6' },
  { label: '出库增长异动', value: 7, lang: 'enum.alarmTypeEnum7' },
  { label: '入库增长异动', value: 8, lang: 'enum.alarmTypeEnum8' }
]

// 异动等级枚举
export const alarmLevelEnum = [
  { label: '一级异动', value: 1, lang: 'enum.alarmLevelEnum1' },
  { label: '二级异动', value: 2, lang: 'enum.alarmLevelEnum2' },
  { label: '三级异动', value: 3, lang: 'enum.alarmLevelEnum3' }
]

// 异动客户等级枚举
export const alarmCustomerLevelEnum = [
  { label: '0-5万', value: 1, lang: 'enum.alarmCustomerLevelEnum1' },
  { label: '5万-20万', value: 2, lang: 'enum.alarmCustomerLevelEnum2' },
  { label: '20万-50万', value: 3, lang: 'enum.alarmCustomerLevelEnum3' },
  { label: '50万以上', value: 4, lang: 'enum.alarmCustomerLevelEnum4' }
]

// 异动处理状态枚举
export const alarmProcessStatusEnum = [
  { label: '未反馈', value: 1, lang: 'enum.alarmProcessStatus1' },
  { label: '超时未反馈', value: 2, lang: 'enum.alarmProcessStatus2' },
  { label: '已反馈', value: 3, lang: 'enum.alarmProcessStatus3' },
  { label: '超时已反馈', value: 4, lang: 'enum.alarmProcessStatus4' }
]
// OA审核状态（新客评审或者激活客户）
export const oaReviewStatus = [
  { value: '20', label: '审核中', color: '#3F97FF', lang: 'operate.gdsj83' },
  { value: '30', label: '已通过', color: '#3FAC46', lang: 'operate.cfq4cr' },
  { value: '11', label: '已驳回', color: '#DF443B', lang: 'operate.fvmvfe' },
  { value: '10', label: '草稿', color: '#3F97FF', lang: 'operate.53g2g6' }
]
export default {
  alarmTypeEnum,
  alarmLevelEnum,
  alarmCustomerLevelEnum,
  customerTypeEnum,
  alarmProcessStatusEnum,
  customerPhaseEnum,
  potentialStatusEnum,
  contractStatusEnum,
  clientsStatusEnum,
  customerAllStatusEnum,
  customerUnfollowDayTypeEnum,
  flagEnum,
  enterpriseScaleEnum,
  contactTypeEnum,
  genderEnum,
  linkRoleTypeEnum,
  clueAndcustomerPhaseEnum,
  businessStatusEnum,
  orderTypeEnum,
  customerGradeEnum,
  arkCodeStatusEnum,
  remanentFollowDayTypeEnum
}
